import { ArrowRightOutlined, CaretRightOutlined, RightOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Row, Typography } from 'antd';
import * as React from 'react';
// import { Learn } from './Learn';
import { Stats } from './Stats';
// import { Usage } from './Usage';

const Dashboard: React.FC<{ accountId: string }> = ({ accountId }) => {
  return (
    <div>
      <div style={{
        display: 'flex',
        flexFlow: 'row nowrap',
        marginTop: 14,
        fontSize: 16,
        alignItems: 'center'
      }}>
        <div style={{
          flex: '1 0'
        }}>
          <Typography.Link
            href="/formtopia/docs"
            style={{
              color: '#531dab',
            }}
            strong
          >
            Learn more about building forms in the documentation
            <RightOutlined style={{
              fontSize: '.65em',
              verticalAlign: 'baseline',
              paddingLeft: '.5em'
            }} />
          </Typography.Link>
        </div>
      </div>
      {/* <Usage /> */}
      {/* <Learn /> */}
      <Stats accountId={accountId} />
    </div>
  );
};

export default Dashboard;
